module.exports = __webpack_public_path__ + "static/vegetables-9ed88304eaa080ccf9873af25ce15807.jpg";